import React from "react"
import tw, { styled } from "twin.macro"

const Award = (props) => {
  const IconComponent = props.relationships.icon
    ? require(`../../assets/${props.relationships.icon.name}.inline.svg`)
    : null
  return (
    <Style className="award">
      {IconComponent ? (
        <div className="icon theme--primary">
          <IconComponent />
        </div>
      ) : null}
      <h4>{props.award}</h4>
      <small>{props.awardedBy}</small>
      <time>{props.awardYear}</time>
    </Style>
  )
}
export default Award

const Style = styled.div`
  ${tw`flex flex-col text-center gap-y-2`}

  * + & {
    margin-top: 2em;
  }

  .icon {
    ${tw`flex justify-center mb-1`}

    svg {
      width: auto;
      max-height: 3.25em;
    }
  }

  > h4 {
    font-size: 1.15em;
    color: var(--nova-default);
    ${tw`font-bold order-3 uppercase mb-0 text-pretty`}
  }

  > small {
    ${tw`text-gray-600 order-2`}
  }

  > time {
    order: 4;
    font-weight: 600;
    font-size: 0.85em;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--nova-default);

    &::before,
    &::after {
      content: "";
      width: 1.25em;
      height: 1px;
      margin: 0 0.5em;
      ${tw`bg-black`}
      display: inline-block;
    }
  }
`
